import React from "react";
import { Box, Typography, Button } from "@mui/material";
import {useTranslation} from "react-i18next";
import {DASHBOARD} from "../../../locales/components/namespaces";

export default function AddressCard({
                                        title,
                                        lines = [],
                                        onEdit,
                                        onDelete,
                                    }) {
    const { t } = useTranslation(DASHBOARD);
    return (
        <Box
            sx={{
                backgroundColor: "#F0F0F0",
                borderRadius: "20px",
                p: "30px",
                display: "flex",
                flexDirection: "column",
                gap: "30px",
                width: { xs: "100%", md: 390 },
                minHeight: 345,
            }}
        >
            {/* Title */}
            <Typography
                sx={{
                    fontFamily: "'Zen Maru Gothic', sans-serif",
                    fontWeight: 900,
                    fontSize: 24,
                    lineHeight: "110%",
                    color: "#101010",
                }}
            >
                {title}
            </Typography>

            {/* Address lines */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
                {lines.map((line, i) => (
                    <Typography
                        key={i}
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontSize: 16,
                            lineHeight: "120%",
                            color: "#000",
                        }}
                    >
                        {line}
                    </Typography>
                ))}
            </Box>

            {/* Actions */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "15px",
                }}
            >
                {/* Edit button */}
                <Button
                    onClick={onEdit}
                    sx={{
                        backgroundColor: "#E5007E",
                        border: "1px solid #E5007E",
                        color: "#FCFCFC",
                        borderRadius: "80px",
                        px: "30px",
                        py: "10px",
                        height: "35px",
                        fontFamily: "'Zen Maru Gothic', sans-serif",
                        fontWeight: 900,
                        fontSize: 12,
                        "&:hover": {
                            backgroundColor: "#C2006B",
                            borderColor: "#C2006B",
                        },
                    }}
                >
                    {t('Edit')}
                </Button>

                {/* Delete button */}
                <Button
                    onClick={onDelete}
                    sx={{
                        backgroundColor: "#FCFCFC",
                        border: "1px solid #E5007E",
                        color: "#E5007E",
                        borderRadius: "80px",
                        px: "30px",
                        py: "10px",
                        height: "35px",
                        fontFamily: "'Zen Maru Gothic', sans-serif",
                        fontWeight: 900,
                        fontSize: 12,
                        "&:hover": {
                            backgroundColor: "#FFE5F3",
                            borderColor: "#C2006B",
                            color: "#C2006B",
                        },
                    }}
                >
                    {t('Delete')}
                </Button>
            </Box>
        </Box>
    );
}
